export const LOGIN_PAGE_ID = "login";
export const CALENDAR_PAGE_ID = "calendar";
export const ANALYSIS_PAGE_ID = "analysis";
export const USERS_PAGE_ID = "users";
export const PERFORMANCES_PAGE_ID = "performances";
export const SPLASH_SCREEN_PAGE_ID = "splash";
